import React from 'react'
import { ExternalButtonLink } from 'stylist'

const SUBJECT = 'FV Login Issue'

export default ({ email, message, ...rest }) => (
  <ExternalButtonLink
    href={`mailto:${email}?subject=${SUBJECT}&body=${window.encodeURIComponent(
      message
    )}`}
    {...rest}
  >
    Contact Helpdesk
  </ExternalButtonLink>
)



// WEBPACK FOOTER //
// ./src/routes/errors/components/EmailSupportButton.js